import { ADMIN_TOKEN_KEY } from '@/config';

const AuthTokenStorageService = {
  store(accessToken) {
    window.$cookies.set(ADMIN_TOKEN_KEY, accessToken, '', '');
  },

  getAccessToken() {
    return window.$cookies.get(ADMIN_TOKEN_KEY);
  },

  clear() {
    window.$cookies.remove(ADMIN_TOKEN_KEY);
  },
};

export default AuthTokenStorageService;
